import { render, staticRenderFns } from "./showFile.vue?vue&type=template&id=d64cf096"
import script from "./showFile.vue?vue&type=script&lang=js"
export * from "./showFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports